import React, { FC, PropsWithChildren } from "react";
import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { Avatar } from "../Avatar";
import "./ChatMessagePart.scss";

export interface ChatMessagePartProps {
  readonly showAvatar: boolean;
  readonly user: ChatUserInfo;
  readonly avatarPosition?: string; // Default is 'left'
  readonly hideUserInfo?: boolean; // When true, hides user name and avatar when avatarPosition is 'bottom'
  readonly fullWidth?: boolean; // When true, expands to full width (for lists, etc.)
}

function renderAvatar(entity: ChatUserInfo) {
  return (
    <div className="xappw-chat-msg-part__avatar">
      <Avatar entity={entity} />
    </div>
  );
}

export const ChatMessagePart: FC<PropsWithChildren<ChatMessagePartProps>> = (props) => {
  const position = props.avatarPosition ?? "left";
  const containerClass =
    "xappw-chat-msg-part" +
    (position === "below" ? " xappw-chat-msg-part--avatar-below" : "") +
    (position === "bottom" ? " xappw-chat-msg-part--avatar-bottom" : "") +
    (props.fullWidth ? " xappw-chat-msg-part--full-width" : "");

  const { user, hideUserInfo } = props;

  // Hide user info if hideUserInfo is true and position is "bottom"
  const shouldHideUserInfo = hideUserInfo && position === "bottom";

  return (
    <div className={containerClass}>
      {position === "left" ? (
        <>
          {props.showAvatar && renderAvatar(user)}
          {props.children}
        </>
      ) : (
        <>
          {props.children}
          {props.showAvatar && !shouldHideUserInfo && (
            <div className="xappw-chat-msg-part__avatar-wrapper">
              {renderAvatar(user)}
              {user?.displayName && (
                <div className="xappw-chat-msg-part__avatar-name">
                  {user.displayName}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
